export const deleteSearchParams = (
  key: string
): {
  newPathname: string;
  searchKeyValue: string | null;
} => {
  const search = window.location.search;
  const query = new URLSearchParams(search);

  const searchKeyValue = query.get(key);

  query.delete(key);

  return {
    newPathname:
      window.location.pathname +
      (query.toString().length > 0 ? `?${query.toString()}` : ''),
    searchKeyValue,
  };
};

export const replaceHistoryState = (newPathname: string) => {
  window.history.replaceState(
    {
      url: newPathname,
      as: newPathname,
      options: {},
      __N: true,
    },
    '',
    newPathname
  );
};
